import {LFO} from 'constants/mod-types.js';

class ParameterMod {
    constructor(parameter, modulator, scale, scales, type=LFO) {
        this.parameter = parameter;
        this.modulator = modulator;
        this.scale = scale;
        this.scales = scales;
        this.type = type;

        if (this.scale === undefined && this.scales !== undefined) {
            this.scale = this.scales[0];
        }
    }

    getJson() {
        return {
            modulator: this.modulator.number,
            min: this.scale.min,
            max: this.scale.max,
            type: this.type,
        };
    }

    get min() {
        return this.scale.min;
    }

    get max() {
        return this.scale.max;
    }

    set min(x) {
        if (x === undefined) {
            return;
        }
        if (this.scales !== undefined) {
            this.scales.forEach(scale => scale.min = x);
        } else {
            this.scale.min = x;
        }
    }

    set max(x) {
        if (x === undefined) {
            return;
        }
        if (this.scales !== undefined) {
            this.scales.forEach(scale => scale.max = x);
        } else {
            this.scale.max = x;
        }
    }
}

export default ParameterMod;
